export const handleChangeWhiteSpace = (value: string) => {
  return value.trim();
};
